@if (anyStatus) {
  <div class="status-container"
    ngbTooltip="{{statusTooltip}}" container="body" tooltipClass="myTooltip">
    <div class="status-light" [class.offline]="offline" [class.online]="online" [class.wait]="wait"></div>
  </div>
}
